// extracted by mini-css-extract-plugin
module.exports = {"root":"RecipeLabel_root__kDnXl","rounded":"RecipeLabel_rounded__7m_4J","useFade-fadeIn":"RecipeLabel_useFade-fadeIn__ANLwp","useFade-fadeOut":"RecipeLabel_useFade-fadeOut__ROp_M"};